export default __webpack_public_path__ + "static/media/ProtestHeaderImage.5465aa59.svg";